const listaDeWorkflows = (state) => {
    return state.items;
}

const listaDeTiposAgings = (state) => {
    return state.tipoAgings;
}

const loadingWorkflows = (state) => {
    return state.carregando
}

export {
    listaDeWorkflows,
    listaDeTiposAgings,
    loadingWorkflows
}